<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-small-size-100 md-size-33">
        <!-- TODO: Move to a separate component (Select) -->
        <md-field>
          <md-select v-model="filterBy">
            <md-option value="DAY">Last 24 Hours</md-option>

            <md-option value="MONTH">Last 30 Days</md-option>
            <md-option value="YEAR">Last 12 Months</md-option>
          </md-select>
        </md-field>
      </div>
    </div>

    <div class="md-layout cards">
      <!-- Total Transaction Volume -->
      <div
        class="md-layout-item md-medium-size-50 md-small-size-100 md-size-50"
      >
        <stats-card data-background-color="orange">
          <template slot="header">
            <md-icon>assessment</md-icon>
          </template>

          <template slot="content">
            <p class="category">Transaction Count</p>
            <p class="title" v-if="this.$store.state.isSummaryCardLoading">...</p>
            <h3 class="title" v-else>{{ this.summary.count || 0 }}</h3>
          </template>
        </stats-card>
      </div>
      <!-- Total Transaction Amount -->
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50"
      >
        <stats-card data-background-color="orange">
          <template slot="header">
            <md-icon>assessment</md-icon>
          </template>
          <template slot="content">
            <p class="category">Transaction Volume</p>
            <p class="title" v-if="this.$store.state.isSummaryCardLoading">...</p>
            <h3 class="title" v-else>
              {{ formatAmount(this.summary.volume) || formatAmount(0) }}
            </h3>
          </template>
        </stats-card>
      </div>
    </div>
    <DashboardCharts
      :isPerformanceLoading="isPerformanceLoading"
      :isSalesLoading="isSalesLoading"
    />
  </div>
</template>

<script>
import format from 'date-fns/format';
import { StatsCard } from '../components/index';
import http from '../utils/Http.util';
import { formatAmount } from '../utils/Formatter.util';
import DashboardCharts from '../components/Charts/DashboardCharts.vue';

export default {
  components: {
    StatsCard,
    DashboardCharts,
  },
  computed: {
    interval() {
      return this.$store.state.interval;
    },
    userData() {
      return this.$store.state.userData;
    },
    activeBusiness() {
      return this.$store.state.activeBusiness;
    },
    getTotalSales() {
      const sum = this.performance.reduce((a, b) => a + b, 0);
      return sum;
    },
    isLive() {
      return this.$store.state.isLive;
    },
  },
  watch: {
    filterBy() {
      // localStorage.setItem('queryInterval', this.filterBy);
      this.$store.commit('setQueryInterval', this.filterBy);
      this.filter();
    },
  },

  created() {
    this.filter();
  },
  data() {
    return {
      performance: [],
      filterBy: this.$store.state.queryInterval,
      isSummaryLoading: false,
      isPerformanceLoading: false,
      isSalesLoading: false,
      summary: {
        vend: 0,
        commission: 0,
      },
      snackBar: {
        show: false,
        message: null,
      },
    };
  },
  methods: {
    formatAmount,
    filter() {
      this.getSummary();
      this.getSalesAnalytics();
      this.getPerformanceAnalytics();
    },

    getSummary() {
      this.isSummaryLoading = true;
      this.$store.commit('setIsSummaryCardLoading', true);

      const interval = this.getInterval();
      http
        .authReq(`/dashboard/aggregation/summary?view=${interval.view}`)
        .then(({ data }) => {
          this.summary = data;
          this.isSummaryLoading = false;
          this.$store.commit('setIsSummaryCardLoading', false);
        })
        .catch((err) => {
          this.snackBar = {
            show: true,
            message: err.response ? err.response.data.message : err.message,
          };
          this.isSummaryLoading = false;
          this.$store.commit('setIsSummaryCardLoading', false);
        });
    },
    getSalesAnalytics() {
      this.isSalesLoading = true;
      this.$store.commit('setIsSalesChartLoading', true);
      const interval = this.getInterval();
      http
        .authReq(
          `/dashboard/aggregation/sales?view=${interval.view}&precision=${
            interval.precision
          }`,
        )
        .then((result) => {
          const { data } = result;
          this.formatSalesAnalyticsData(data);
          this.isSalesLoading = false;
          this.$store.commit('setIsSalesChartLoading', false);
        })
        .catch((err) => {
          this.snackBar = {
            show: true,
            message: err.response ? err.response.data.message : err.message,
          };
          this.isSalesLoading = false;
          this.$store.commit('setIsSalesChartLoading', false);
        });
    },

    formatSalesAnalyticsData(salesData) {
      const xAxis = [];
      const yAxis = [];

      Object.keys(salesData).forEach((key) => {
        const value = salesData[key];
        xAxis.push(format(key, 'YYYY-MM-DD HH:MM:SS'));
        yAxis.push(value);
      });

      const sales = { xAxis, yAxis };
      this.$store.commit('setSales', sales);
    },

    getPerformanceAnalytics() {
      this.isPerformanceLoading = true;
      this.$store.commit('setIsPerformanceChartLoading', true);

      const interval = this.getInterval();
      // this.isLive
      http
        .authReq(
          `/dashboard/aggregation/performance?view=${interval.view}&precision=${
            interval.precision
          }`,
        )
        .then(({ data }) => {
          const { SUCCESSFUL, PENDING, FAILED } = data;
          const performance = [SUCCESSFUL, PENDING, FAILED];
          this.performance = performance;
          this.$store.commit('setPerformance', performance);
          this.isPerformanceLoading = false;
          this.$store.commit('setIsPerformanceChartLoading', false);
        })
        .catch((err) => {
          this.snackBar = {
            show: true,
            message: err.response ? err.response.data.message : err.message,
          };
          this.isPerformanceLoading = false;
          this.$store.commit('setIsPerformanceChartLoading', false);
        });
    },

    getInterval() {
      let queryInterval = { view: '', interval: '' };

      switch (this.filterBy) {
        case 'DAY':
          queryInterval = { view: 'DAY', precision: 'HOURLY' };
          break;
        case 'WEEK':
          queryInterval = { view: 'WEEK', precision: 'DAILY' };
          break;
        case 'MONTH':
          queryInterval = { view: 'MONTH', precision: 'DAILY' };
          break;
        case 'YEAR':
          queryInterval = { view: 'YEAR', precision: 'MONTHLY' };
          break;

        default:
          break;
      }

      return queryInterval;
    },
  },
};
</script>

<style scoped>
.md-select {
  background: white !important;
  padding: 5px;
}
</style>

<style>
.content {
  padding-top: 0 !important;
}
</style>
